<template>
  <tabs parent="client_list">
    <tab id="clients" :name="translate('client.many')" :href="url + '/clients'">
      <keep-alive>
        <Clients />
      </keep-alive>
    </tab>
    <tab :isVisible="$store.getters.getPermissions.permissionGod === true" id="groups" :name="translate('client_groups.many')" :href="url + '/groups'">
      <keep-alive>
        <Groups />
      </keep-alive>
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Clients from './Tabs/Clients/Index.vue'
import Groups from './Tabs/Groups/Index.vue'

export default {
  name: 'ClientList',
  components: {
    Tabs,
    Tab,
    Clients,
    Groups
  },
  computed: {
    url () { return '/client_list' }
  }
}
</script>
